var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwards2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.102,
    height: 52.153,
    viewBox: "0 0 52.102 52.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "awards",
    transform: "translate(-0.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M5.645,314.594.7,319.542a1.528,1.528,0,0,0,.627,2.54l8.811,2.735,2.735,8.811a1.528,1.528,0,0,0,2.54.627l7.712-7.712A23.684,23.684,0,0,1,5.645,314.594Z",
    transform: "translate(0 -282.549)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M309.633,319.542l-4.948-4.948a23.684,23.684,0,0,1-17.477,11.948l7.712,7.712a1.528,1.528,0,0,0,2.54-.627l2.735-8.811,8.811-2.735a1.528,1.528,0,0,0,.627-2.54Z",
    transform: "translate(-257.729 -282.549)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M153.612,88a11.612,11.612,0,1,0,11.612,11.612A11.625,11.625,0,0,0,153.612,88Zm5.7,13.723.173,4.063a1.528,1.528,0,0,1-2.06,1.5l-3.81-1.42-3.81,1.42a1.528,1.528,0,0,1-2.06-1.5l.173-4.063-2.528-3.185a1.528,1.528,0,0,1,.787-2.422l3.917-1.091,2.248-3.389a1.528,1.528,0,0,1,2.547,0l2.248,3.389,3.917,1.091a1.528,1.528,0,0,1,.787,2.422Z",
    transform: "translate(-127.312 -79.036)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M218.5,161.081l-1.289-1.944-1.289,1.944a1.528,1.528,0,0,1-.864.627l-2.247.625,1.45,1.827a1.528,1.528,0,0,1,.33,1.015l-.1,2.33,2.185-.815a1.527,1.527,0,0,1,1.067,0l2.185.815-.1-2.33a1.529,1.529,0,0,1,.33-1.015l1.45-1.827-2.247-.625A1.529,1.529,0,0,1,218.5,161.081Z",
    transform: "translate(-190.907 -142.927)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M95.152,20.576A20.576,20.576,0,1,0,74.576,41.152,20.6,20.6,0,0,0,95.152,20.576ZM74.576,35.244A14.668,14.668,0,1,1,89.244,20.576,14.685,14.685,0,0,1,74.576,35.244Z",
    transform: "translate(-48.276)",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwards2);
export default __webpack_public_path__ + "static/media/awards_2.9c7109dadff227c4114e0272946674a6.svg";
export { ForwardRef as ReactComponent };